import {Button, Dialog,DialogActions,DialogContent,DialogTitle, ListSubheader, MenuItem, Select} from "@mui/material";
import React, { useEffect } from "react";
import Loading from "../../../Loading";
import { net } from "../../../../../database";
import mut from "../../../hooks/mut";


export default function EditSyllabusDialog(props) {
    const { open, setOpen, lesson, refresh} = props;
  const [syl, setSyl] = React.useState(undefined);
  const [courseLesson, setCourseLesson] = React.useState(lesson.courseLesson);
    useEffect(() => { 
        if(open) {
           net.get("/get-syllabus-for-class/" + lesson.htClass).then((res) => {
             setSyl(res);
           });
 

        }
     
    }, [open]);
    if (!open) return null;
  if (open && !syl) return <Loading />;

  
  const updateServer = async () => { 
    await mut("post",
      `/update-lesson-number/${lesson._id}`,
      { courseLesson }
    );
    refresh()
    setOpen(false);
  }
 
    const {syls,htc} = syl
  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>Update lesson for this class</DialogTitle>
      <DialogContent>
        <div className="p-2">This will re-order all future lessons to the order in the syllabus</div>
    
          <ChooseLesson syllabus={syls.find(s => s._id === htc.syllabus)} value={courseLesson} setValue={setCourseLesson} />
  
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button color="success" onClick={updateServer}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}


function ChooseLesson({ syllabus, value, setValue }) {
  return (
    <Select
      value={value}
      onChange={(e) => {
        console.log(e.target.value);
        setValue(e.target.value);
      }}
      className="w-max"
    >
      {syllabus.units.flatMap((unit, i) => [
        <ListSubheader key={`header-${i}`}>
          {unit.unitNumber}. {unit.name}
        </ListSubheader>,
        ...unit.lessons.map((lesson, j) => (
          <MenuItem
            key={`lesson-${i}-${j}`}
            value={lesson.courseLessonNumber}
          >
            {lesson.lessonNumber}. {lesson.name}
          </MenuItem>
        )),
        <MenuItem
          key={`test-${i}`}
          value={unit.testLessonNumber}
        >
          Unit {unit.unitNumber} Test
        </MenuItem>,
      ])}
    </Select>
  );
}
